module.exports = {
  siteTitle: 'Het Delwadiya',
  siteDescription:
    'A portfolio of Het Delwadiya.',
  siteKeywords:
    'Het Delwadiya, Het, Delwadiya, hetdelwadiya, software engineer, senior software engineer, web developer, javascript, typescript, mongodb',
  siteUrl: 'https://hetdelwadiya.dev/',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-353018797',
  googleVerification: 'DCl7VAf9tcz6eD9gb67NfkNnJ1PKRNcg8qQiwpsadasd',
  name: 'Het Delwadiya',
  location: 'Pune, India',
  email: 'hello@hetdelwadiya.dev',
  github: 'https://github.com/het-delwadiya',
  twitterHandle: '@hetdelwadiya',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/het-delwadiya',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/hetdelwadiya/',
    },
    {
      name: 'NPMJS',
      url: 'https://www.npmjs.com/~het_delwadiya',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/het_delwadiya',
    }
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
